module.exports = __webpack_public_path__ + "img/NCB.795e7fd3.svg";